import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { RoundedLabel } from '@/components/elements/RoundedLabel'
import { Spacer } from '@/components/elements/Spacer'

type Props = {
  title: string
  subtitle: string
  link: string
  imgPath: string
}

export const CmsLinkCard = ({ title, subtitle, link, imgPath }: Props) => {
  return (
    <Link href={link} passHref>
      <StyledLink>
        <Wrapper>
          <ImageWrapper>
            <img src={imgPath} width="74" height="70" alt="" />
          </ImageWrapper>
          <Spacer h={{ sp: 16, pc: 7 }} />
          <Subtitle>{subtitle}</Subtitle>
          <Spacer h={{ sp: 17, pc: 11 }} />
          <RoundedLabel>{title}</RoundedLabel>
        </Wrapper>
      </StyledLink>
    </Link>
  )
}

const StyledLink = styled.a`
  display: block;
  width: 316px;

  &:hover > div {
    > div > img {
      opacity: 0.6;
      transition: opacity 0.25s ease;
    }

    > div:last-of-type {
      background: ${theme.colors.hoverLightBlue};
      transition: background 0.25s ease;
      opacity: 1;
    }
  }

  &:hover > div > div:first-of-type {
    > div > img {
      opacity: 0.6;
      transition: opacity 0.25s ease;
    }

    > div:nth-of-type(2) {
      background: ${theme.colors.hoverLightBlue};
      transition: background 0.25s ease;
    }
  }

  @media screen and (max-width: 1047px) {
    width: 335px;
  }
`

const Wrapper = styled.div`
  width: 316px;
  height: 188px;
  background: ${theme.colors.backgroundPaleBlue};
  border-radius: 8px;
  padding: 18px 21px 21px 21px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1047px) {
    width: 100%;
    height: 208px;
    padding: 24px 12px 18px;
  }
`

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  transition: opacity 0.25s ease;
`

const Subtitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${theme.colors.trialBlue};
  text-align: center;

  @media screen and (max-width: 1047px) {
    font-size: 18px;
  }
`
